var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDeactivated(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 244.02 49.04",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".bf09e8b9-780a-4051-bd00-1d7ffbfb9bb8{fill:none;stroke:#89a6df;stroke-linecap:round;stroke-linejoin:round;stroke-width:3px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ef59a348-5f23-4307-8d65-3733d3974f65",
    "data-name": "Layer 9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "bf09e8b9-780a-4051-bd00-1d7ffbfb9bb8",
    d: "M22.19,8.72h92.56a3.58,3.58,0,0,1,1.81.48l53.76,30.64a3.64,3.64,0,0,0,3.69,0l47.82-28.69"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeactivated);
export default __webpack_public_path__ + "static/media/deactivated.8b3a4dc9.svg";
export { ForwardRef as ReactComponent };